import { FaStar } from "react-icons/fa";
import type { TAddCommentResponse } from "../../services/comment";

interface CommentCardProps {
  comment: TAddCommentResponse;
}

const CommentCard = ({ comment }: CommentCardProps) => {
  return (
    <div className="h-full relative">
      <img
        src="/images/avatar_3.png"
        alt="avatar"
        className="w-[62px] h-[62px] rounded-full object-cover absolute right-2 top-2 z-10"
      />

      <div dir="ltr" className="flex flex-col h-full">
        <div className="flex flex-row-reverse items-center justify-between gap-2 flex-wrap pr-20 pl-2 pt-5">
          <p className="font-kalameh text-lg lg:text-2xl text-white">
            {comment.user.fullName}
          </p>
          <div className="flex flex-row-reverse items-center gap-1">
            {[1, 2, 3, 4, 5].map((star) => (
              <FaStar
                key={star}
                className={`text-2xl ${
                  star <= comment.rate ? "text-yellow-400" : "text-gray-400"
                }`}
              />
            ))}
          </div>
        </div>

        <p className="font-kalameh mt-4 py-2 pr-2.5 text-[20px] md:text-lg text-white font-light leading-[26px] text-right mx-8 overflow-y-auto scrollbar-thin scrollbar-thumb-white/80 scrollbar-track-transparent">
          {comment.text}
        </p>
      </div>
      <style>
        {`
          .scrollbar-thin::-webkit-scrollbar {
            width: 4px;
          }
          .scrollbar-thin::-webkit-scrollbar-track {
            background: transparent;
          }
          .scrollbar-thin::-webkit-scrollbar-thumb {
            background-color: rgba(255, 255, 255, 0.8);
            border-radius: 9999px;
          }
        `}
      </style>
    </div>
  );
};

export default CommentCard;
